export const ProblemRule = {
    "cancelManualCallReprogramed":"cancelManualCallReprogramed",
    "GetAgentID":"GetAgentID",
    "GetCampaignsRelated":"GetCampaignsRelated",
    "getChatHistory":"getChatHistory",
    "GetExtension":"GetExtension",
    "getLastCallData":"getLastCallData",
    "getSupervisorsToChat":"getSupervisorsToChat",
    "getUnavailables":"getUnavailables",
    "getUnavailableHistory":"getUnavailableHistory",
    "GetUserName":"getUserName",
    "Logout":"Logout",
    "makeManualCall":"makeManualCall",
    "sendClientChatMessage":"sendClientChatMessage",
};



// WEBPACK FOOTER //
// ./src/BusinessRule/ProblemRule.js